var _g, _rect, _circle, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlowhorn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 392,
    height: 306,
    viewBox: "0 0 392 306",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_469_1533)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 37,
    width: 286,
    height: 200,
    rx: 10,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 52,
    width: 30,
    height: 15,
    rx: 7.5,
    fill: "#EF069A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 308.5,
    cy: 59.5,
    r: 5.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 110,
    width: 208,
    height: 54,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_469_1533",
    x: 0,
    y: 0,
    width: 392,
    height: 306,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_469_1533"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_469_1533"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_469_1533",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_469_1533",
    transform: "scale(0.00480769 0.0185185)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_469_1533",
    width: 208,
    height: 54,
    xlinkHref: "data:image/png;base64,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"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlowhorn);
export default __webpack_public_path__ + "static/media/blowhorn.d52279d3815812a259f126b5843fdbb5.svg";
export { ForwardRef as ReactComponent };